<template>
  <div>
    <div>
      <h3 class="title-color">Site Owner Info</h3>
    </div>
    <div class="e-card-separator"></div>
    <div class="main-container">
      <site-owner-info
        @updateAddress="updateAddress"
        :company="permit.ePermitSite.ownerCompany"
        @updateOwner="updateOwner"
        companySearchType="owner"
        :applier="applier"
        :ownerDataSource="uniqueOwners"
        ownerPlaceholder="Owner Number: "
        :ownerFields="fields"
      />
      <!-- <div class="e-card-separator"></div> -->
      <!-- <select-municipality /> -->
      <div class="e-card-separator"></div>
      <contact-info
        ref="ownerContactRef"
        @updateContactNumber="updateContactNumber"
        @updateContactInfo="updateContactInfo"
        :phoneRules="[phoneRule]"
        :emailRules="[emailRule]"
        :applier="applier"
        :contact="permit.ePermitSite.ownerContact"
        :contactFieldDataSource="contactFieldDataSource"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { emailRule, phoneRule } from '@/shared/constants';
import ContactInfo from './common/contact-info.vue';
import { applierTypeEnum } from './constants';
import SiteOwnerInfo from './common/site-owner-info.vue';
import {
  updateContactNumber,
  updateContactInfo,
} from './helper';
// import SelectMunicipality from './common/select-municipality.vue';

export default {
  name: 'OwnerInfo',
  props: {
    owners: Array,
  },

  components: {
    ContactInfo,
    SiteOwnerInfo,
    // SelectMunicipality,
  },

  data() {
    return {
      fields: { text: 'ownerID', value: 'ownerID' },
      phoneRule,
      emailRule,
      applier: applierTypeEnum.SITEOWNER,
      contactFieldDataSource: null,
      ownerContacts: null,
    };
  },
  computed: {
    ...mapGetters({
      permit: 'permit',
    }),
    uniqueOwners() {
      if (this.owners) {
        return this.owners.filter((sx) => sx.uniqueFlage === 1);
      }
      return this.owners;
    },
  },
  watch: {
    permit(val) {
      if (val && val.ePermitSite && val.ePermitSite.ownerID && !this.ownerContacts) {
        // eslint-disable-next-line max-len
        this.ownerContacts = this.owners.filter((sx) => sx.ownerID === val.ePermitSite.ownerID).map((x) => ({
          fName: x.fName,
          lName: x.lName,
          phoneNumber: x.phoneNumber,
          name: `${x.fName} ${x.lName}`,
          emailAddress: x.emailAddress,
          ownerContactID: x.ownerContactID,
        }));
        this.contactFieldDataSource = this.ownerContacts;
      }
    },
  },
  methods: {
    updateOwner(data) {
      if (data) {
        let contactId = null;
        const val = data.ownerID
          ? data.ownerID
          : this.owners.find((x) => x.sourceCompanyId === data.sourceCompanyId)
            ?.ownerID;
        if (val) {
          // eslint-disable-next-line max-len
          this.ownerContacts = this.owners.filter((sx) => sx.ownerID === parseInt(val, 0)).map((x) => ({
            fName: x.fName,
            lName: x.lName,
            phoneNumber: x.phoneNumber,
            name: `${x.fName} ${x.lName}`,
            emailAddress: x.emailAddress,
            ownerContactID: x.ownerContactID,
          }));
          // this.updateContactFieldDS(this.ownerContacts);
          this.contactFieldDataSource = this.ownerContacts;
          // -- get default contact as default of dropdown.
          const owner = this.uniqueOwners.find((x) => x.ownerID === parseInt(val, 0));
          if (owner) {
            this.updateContactInfo(owner);
            if (data.sourceCompanyId) {
              // this.updateContactInfo(data);
            } else {
              // eslint-disable-next-line no-param-reassign
              data.sourceCompanyId = owner.sourceCompanyId;
            }
            this.permit.ePermitSite.ownerID = owner.ownerID;
            // this.permit.ePermitSite.ownerCompany = owner;
            contactId = owner.ownerContactID;
            // eslint-disable-next-line no-param-reassign
            data.legalName = owner.legalName;
            // eslint-disable-next-line no-param-reassign
            data.provinceName = owner.provinceName;
            // eslint-disable-next-line no-param-reassign
            data.postalCode = owner.postalCode;
            // eslint-disable-next-line no-param-reassign
            data.countryName = owner.countryName;
            // eslint-disable-next-line no-param-reassign
            data.cityName = owner.cityName;
            // eslint-disable-next-line no-param-reassign
            data.address = owner.address;
            // eslint-disable-next-line no-param-reassign
            data.sourceCompanyId = owner.sourceCompanyId;
            // eslint-disable-next-line no-param-reassign
            data.contactId = owner.contactId;
            // eslint-disable-next-line no-param-reassign
            data.fName = owner.fName;
            // eslint-disable-next-line no-param-reassign
            data.lName = owner.lName;
            // eslint-disable-next-line no-param-reassign
            data.phone = owner.phone;
            // eslint-disable-next-line no-param-reassign
            data.email = owner.email;
          } else {
            if (data.sourceCompanyId) {
              this.updateContactInfo(data);
            }
            this.permit.ePermitSite.ownerID = null;
          }
        } else {
          this.permit.ePermitSite.ownerID = null;
        }
        this.permit.ePermitSite.ownerContact.contactId = contactId;
        // if (data.sourceCompanyId)
        this.permit.ePermitSite.ownerCompany = data;
      } else {
        this.permit.ePermitSite.ownerCompany.legalName = null;
        this.permit.ePermitSite.ownerCompany.provinceName = null;
        this.permit.ePermitSite.ownerCompany.postalCode = null;
        this.permit.ePermitSite.ownerCompany.countryName = null;
        this.permit.ePermitSite.ownerCompany.cityName = null;
        this.permit.ePermitSite.ownerCompany.address = null;
        this.permit.ePermitSite.ownerCompany.sourceCompanyId = null;
        this.permit.ePermitSite.ownerContact.contactId = null;

        this.permit.ePermitSite.ownerContact.fName = null;
        this.permit.ePermitSite.ownerContact.lName = null;
        this.permit.ePermitSite.ownerContact.phone = null;
        this.permit.ePermitSite.ownerContact.altPhone = null;
        this.permit.ePermitSite.ownerContact.email = null;

        this.permit.ePermitSite.ownerID = null;
      }
    },
    updateAddress(data) {
      if (data) {
        if (this.permit.ePermitSite.ownerCompany) {
          this.permit.ePermitSite.ownerCompany.address = data.address;
          this.permit.ePermitSite.ownerCompany.provinceName = data.provinceName;
          this.permit.ePermitSite.ownerCompany.postalCode = data.postalCode;
          this.permit.ePermitSite.ownerCompany.cityName = data.cityName;
          this.permit.ePermitSite.ownerCompany.countryName = data.countryName;
        } else {
          this.permit.ePermitSite.ownerCompany = data;
        }
      }
    },
    updateContactNumber(data) {
      updateContactNumber(data, this.permit.ePermitSite.ownerContact);
    },
    // updateContactFieldDS() {
    //   // updateContactFieldDS(
    //   //   this,
    //   //   dataSource,
    //   //   this.permit.ePermitSite.ownerContact,
    //   // );
    // },
    updateContactInfo(data) {
      updateContactInfo(data, this.permit.ePermitSite.ownerContact);
    },
  },
};
</script>
